import { render } from "./AskAction.vue?vue&type=template&id=19ab9176&scoped=true"
import script from "./AskAction.vue?vue&type=script&lang=js"
export * from "./AskAction.vue?vue&type=script&lang=js"

import "./AskAction.vue?vue&type=style&index=0&id=19ab9176&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ab9176"]])

export default __exports__